module.exports = __webpack_public_path__ + "img/rate_circle.5acf7ec9.svg";